import baseURL from "../common/axios";
class TaskTypeService {
    //To Insert TaskType-->MOPCRM API
    create(dataModel) {
        return baseURL.httpMSMOPCRMUrl.post("TaskType/Create", dataModel);
    }
    //To Update TaskType-->MOPCRM API
    update(dataModel) {
        return baseURL.httpMSMOPCRMUrl.post("TaskType/Update", dataModel);
    }
    //To Delete TaskType-->MOPCRM API
    delete(Id) {
        return baseURL.httpMSMOPCRMUrl.delete("TaskType/Delete?id=" + Id);
    }
    //Active
    active(Id, Status) {
        return baseURL.httpMSMOPCRMUrl.put(
            "TaskType/Active?id=" + Id + "&Status=" + Status + ""
        );
    }
    //To Get TaskType List-->MOPCRM API
    getList() {
        return baseURL.httpMSMOPCRMUrl.get("TaskType/List");
    }
    //To Get TaskType List-->MOPCRM API
    getById(Id) {
        return baseURL.httpMSMOPCRMUrl.get("TaskType/Get?id=" + Id + "");
    }
}
export default new TaskTypeService();
